import { Text } from '@fluentui/react';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <Text variant="small">
            Copyright © {currentYear} WTW. All rights reserved.
        </Text>
    );
};

export default Footer;